import {
  evbus,
  WS
} from "@/shared/ws.js";
import * as types from "../mutation-types";
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    wsPath: endpoints.ws.wsPath, // "ws",
    ws: null,
    notifications: [],
    new: 0,
    status: 0,
    trafic: 0,
  },
  // -----------------------------------------------------------------
  getters: {
    new: state => state.new,
    notifications: state => state.notifications,
    status: state => state.status,
    trafic: state => state.trafic,
    notificationByID: state => id => {
      for (const notification of state.notifications) {
        if (notification.authz_id === id) return notification;
      }
      return undefined;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.NOTIFICATION_ADD](state, data) {
      const notifs = JSON.parse(JSON.stringify(state.notifications));
      notifs.unshift(data);
      state.new = state.new + 1;
      state.notifications = notifs;
    },
    [types.NOTIFICATION_REMOVE](state, id) {
      const notifs = JSON.parse(JSON.stringify(state.notifications));
      let toRemove = 0;
      for (let i = 0; i < notifs.length; i++) {
        if (notifs[i].authz_id === id) {
          notifs.splice(i, 1);
          toRemove += 1;
        }
      }
      if (toRemove) {
        if (state.new >= toRemove) {
          state.new = state.new - toRemove;
        }
        state.notifications = notifs;
      }
    },
    [types.NOTIFICATIONS_CLEAR](state) {
      state.notifications = [];
      state.new = 0;
    },
    [types.NOTIFICATIONS_CHECK](state, data) {
      const notifs = JSON.parse(JSON.stringify(state.notifications));
      let toRemove = 0;
      data.forEach(item => {
        for (let i = 0; i < notifs.length; i++) {
          if (notifs[i].authz_id === item.authz_id) {
            notifs.splice(i, 1);
            toRemove += 1;
          }
        }
      });
      if (toRemove) {
        if (state.new >= toRemove) {
          state.new = state.new - toRemove;
        } else {
          state.new = 0;
        }
        state.notifications = notifs;
      }
    },
    [types.NOTIFICATIONS_NEW_CLEAR](state) {
      state.new = 0;
    }
  },
  // -----------------------------------------------------------------
  actions: {
    connect: (context) => {
      const wsApi = context.rootGetters['global/wsUrl'] + "/" + context.state.wsPath;
      const shouldConnect = true;

      if (context.state.ws != null) {
        return;
      }

      if (shouldConnect) {
        evbus.on("ws.open", () => {
          context.state.status = 1;
        });
        evbus.on("ws.opened", () => {
          context.state.status = 2;
        });
        evbus.on("ws.error", () => {
          context.state.status = 3;
        });
        evbus.on("ws.close", () => {
          context.state.status = 4;
        });
        evbus.on("ws.message", () => {
          context.state.trafic = context.state.trafic + 1;
        });
        context.state.ws = new WS(wsApi, evbus);
      } else {
        console.log("ENABLE WEBSOCKET CONNECTION");
      }
    },

    disconnect: (context) => {
      context.state.ws.close();
      context.state.ws = null;
    },

    addNotification(context, data) {
      context.commit(types.NOTIFICATION_ADD, data);
    },
    checkNotifications(context, data) {
      context.commit(types.NOTIFICATIONS_CHECK, data);
    },
    removeNotification(context, id) {
      context.commit(types.NOTIFICATION_REMOVE, id);
    },
    clearNotifications(context) {
      context.commit(types.NOTIFICATIONS_CLEAR);
    },
    clearNewNotifications(context) {
      context.commit(types.NOTIFICATIONS_NEW_CLEAR);
    }
  }
};
